import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const clientsApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

clientsApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("clients_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const clientsToken = () => localStorage.getItem("clients_token");
export const clientsLogout = () => localStorage.removeItem("clients_token");
